module.exports = __webpack_public_path__ + "static/bloodpop-237ca7f5b7ecee06ebdbb998fc5eb21c.png";